import ReactTooltip from 'rc-tooltip'
import type { PropsWithChildren, FC, ReactElement, ReactNode } from 'react'
import React from 'react'

import 'rc-tooltip/assets/bootstrap.css'
import styles from './Tooltip.module.css'

export type TooltipProps = {
  message?: string | ReactNode
  position?: 'bottom' | 'top' | 'right' | 'left'
}

/**
 * @deprecated Use `libs/ui/ds` Tooltip instead
 * This is used only in planning to allow day view features
 */

export const Tooltip: FC<PropsWithChildren<TooltipProps>> = ({
  children = null,
  message = null,
  position = 'bottom'
}) => {
  if (!message) {
    return children as ReactElement
  }

  return (
    <ReactTooltip
      placement={position}
      overlay={<span className={styles.Tooltip}>{message}</span>}
    >
      <span>{children}</span>
    </ReactTooltip>
  )
}
